<template>
  <a
    :href="`https://capacita.iusa.com.mx/acceso.valida.php?u=${userId}`"
    target="_blank"
  >
    <svg-icon name="iusa-capacita" :label="label" :size="size" />
  </a>
</template>
<script>
  import SvgIcon from './SvgIcon.vue';

  export default {
    name: 'IUSATraining',
    components: { SvgIcon },
    props: {
      size: { type: [String, Number], default: 24 },
      label: {
        type: String,
        default: 'Iusa capacita',
      },
      userId: {
        type: [String, Number],
        required: true,
      },
    },
  };
</script>
